(function() {
"use strict";

const api = {
  SEED: 'seed',
  BUCKETS: 256,
  SAMPLE_SCALE: 1e6,
  SAMPLE_SIZE: 1e9,
  MIN_PRECOMPUTED_OCTAVES: 1,
  MAX_PRECOMPUTED_OCTAVES: 8,
};

module.exports = api;

})();



//////////////////
// WEBPACK FOOTER
// ./node_modules/fast-uniform-noise/src/constants.js
// module id = 6
// module chunks = 0